import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/AuthByContractEpargnEmail/messages';

export default (props: any) =>
  Yup.object().shape({
    email: Yup.string()
      .email(translate({ ...messages.validationErrorMessage }, props))
      .required(translate({ ...messages.requiredField }, props)),
  });
